import request from '@/utils/request'


// 查询提现申请列表
export function listWithdraw(query) {
  return request({
    url: '/withdraw/withdraw/list',
    method: 'get',
    params: query
  })
}

// 查询提现申请分页
export function pageWithdraw(query) {
  return request({
    url: '/withdraw/withdraw/page',
    method: 'get',
    params: query
  })
}

// 查询提现申请详细
export function getWithdraw(data) {
  return request({
    url: '/withdraw/withdraw/detail',
    method: 'get',
    params: data
  })
}

// 新增提现申请
export function addWithdraw(data) {
  return request({
    url: '/withdraw/withdraw/add',
    method: 'post',
    data: data
  })
}

// 修改提现申请
export function updateWithdraw(data) {
  return request({
    url: '/withdraw/withdraw/edit',
    method: 'post',
    data: data
  })
}

// 删除提现申请
export function delWithdraw(data) {
  return request({
    url: '/withdraw/withdraw/delete',
    method: 'post',
    data: data
  })
}
